import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { AdminService } from 'app/app-services';

export const dzAdminGuard: CanActivateFn = activatedRoute => {
  const router = inject(Router);
  const adminService = inject(AdminService);
  const adminId = activatedRoute?.parent?.params?.['id'];

  return adminService
    .getAdmin(adminId)
    .pipe(map(response => (response.data.country === 'DZ' ? true : router.createUrlTree(['/admin-details', adminId, 'admin-profile']))));
};
